module.exports = __webpack_public_path__ + "img/reply-clock.e2ea532c.svg";